export const LOCATION_BUTTONS = {
  specialist: 'specialists',
  clinic: 'practices',
  hospital: 'hospitals'
}